<script setup lang="ts">
import { computed, withDefaults } from 'vue'
import type { textSizes } from 'Common/types/elements/data-display/LabeledReadOnlyText/textSizes'

interface PropTypes {
  label?: string
  labelTextSize?: textSizes
  textSize?: textSizes
}

const props = withDefaults(defineProps<PropTypes>(), {
  label: '',
  labelTextSize: 'sm',
  textSize: '2xl',
  responsive: false,
})

const labelClass = computed<string>(() => {
  return `text-${props.labelTextSize} self-end`
})

const contentClass = computed<string>(() => {
  return `text-${props.textSize} self-start`
})
</script>

<template>
  <div class="grid grid-rows-[33.3%, 66.6%] justify-items-start">
    <span :class="labelClass">
      {{ props.label }}
    </span>
    <span :class="contentClass">
      <slot>No Content</slot>
    </span>
  </div>
</template>
